import React from 'react'
import {
  Alert,
  Button,
  Modal,
  Progress,
  Space,
  Typography,
} from '@surecompanies/core_components'
import { LoadingOutlined } from '@ant-design/icons'
import type { BatchProgress } from './bulkStatus.types'

const { Text } = Typography

interface SubmitProgressModalProps {
  open: boolean
  isCancelling: boolean
  batchProgress: BatchProgress
  onCancel: () => void
}

/**
 * Blocking modal shown while a batch submission is in flight. Not closable
 * (no X, no ESC, no mask click) so the user can't interact with the rest of
 * the page — the only available action is Cancel Upload.
 */
export function SubmitProgressModal({
  open,
  isCancelling,
  batchProgress,
  onCancel,
}: SubmitProgressModalProps) {
  return (
    <Modal
      title={
        <Space size={8}>
          <LoadingOutlined spin style={{ color: '#1677ff' }} />
          <span>Submitting Updates</span>
        </Space>
      }
      open={open}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      width={480}
    >
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Alert
          type="warning"
          showIcon
          message="Please don't close or refresh this page while the update is in progress."
        />
        <Text type="secondary">
          {isCancelling
            ? 'Cancelling… waiting for current batch'
            : `Sending batch ${batchProgress.currentBatch} of ${batchProgress.totalBatches}…`}
        </Text>
        <Progress
          percent={Math.round((batchProgress.sent / batchProgress.total) * 100)}
          format={() => `${batchProgress.sent} / ${batchProgress.total} rows`}
          status={isCancelling ? 'exception' : 'active'}
        />
        <Button danger disabled={isCancelling} onClick={onCancel} block>
          {isCancelling ? 'Cancelling…' : 'Cancel Upload'}
        </Button>
      </Space>
    </Modal>
  )
}
